<template>
  <div
    v-if="recentReports.length > 0 && !userDisabled(identifier)"
    class="reports-widget"
    data-test="reports-widget"
  >
    <div class="widget-header-row" data-test="widget-header-row">
      <dashboard-widget-header
        :icon="widgetIcon"
        :title="config.name"
        :show-close="userHideable"
        @remove-requested="removeRequested(identifier)"
      />
      <router-link
        class="all-reports-link text-sm font-medium text-brand-primary"
        data-test="all-reports-link"
        :to="{ name: 'progressReports#index' }"
        @click="trackReportListView"
      >
        See All
      </router-link>
    </div>

    <div class="list-container">
      <ProgressReportRow
        v-for="progressReport in recentReports"
        :key="progressReport.id"
        :progress-report="progressReport"
        data-test="report-link"
        @click="trackReportView(progressReport)"
      />
    </div>
  </div>
</template>

<script>
import DashboardWidgetHeader from '@/components/dashboard-widgets/header';
import ProgressReportRow from '@/components/progressReports/ProgressReportRow.vue';
import DashboardWidgetMixin from '@/mixins/dashboardWidget';
import WidgetMixin from '@/mixins/widget';

const RECENT_REPORT_COUNT = 4;

export default {
  name: 'ReportsWidget',
  components: { DashboardWidgetHeader, ProgressReportRow },
  mixins: [DashboardWidgetMixin, WidgetMixin],
  props: {
    config: {
      type: Object,
    },
    dashboard: {
      type: Object,
    },
    identifier: {
      type: Number,
    },
    userHideable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    recentReports() {
      return this.$store.getters['progressReports/all'].slice(0, RECENT_REPORT_COUNT);
    },
  },
  methods: {
    trackReportView(progressReport) {
      this.$analytics.events.viewedReportFromWidget({ reportId: progressReport.id });
    },
    trackReportListView() {
      this.$analytics.events.viewedReportList();
    },
  },
};
</script>

<style scoped>
.reports-widget {
  margin-top: 2rem;
}

.widget-header-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 1rem;
}

.all-reports-link {
  white-space: nowrap;
}


</style>